import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Box, Grid, IconButton } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
});

const TransactionSortObj = {
  profile_id: { tableName: 'icustomers', sortColumn: 'profile_id' },
  email: { tableName: 'icustomers', sortColumn: 'email' },
  item_name: { tableName: 'products', sortColumn: 'name' },
  invoice_id: { tableName: '', sortColumn: 'invoice_id' },
  stocked_date: { tableName: '', sortColumn: 'stocked_date' },
  stock_code: { tableName: '', sortColumn: 'stock_code' },
  pickup_code: { tableName: '', sortColumn: 'pickup_code' },
  bin_id: { tableName: '', sortColumn: 'bin_id' },
}

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchObject: null,
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'stocked_date',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 25,
      searchObject: null,
      boxvalues: [],
      accountValues: [],
      loader: false,
      isButtonDisabled: false,
      data: []
    };
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        this.setState({ accountValues: storelist, parent_account_id: storelist[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/RetailStockItemsReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        let csvRow = [];
        let Array = [['ID', 'Profile Id', 'Email', 'InVoice Id', 'Items', 'Stock Code', 'Pickup Code', 'Bin Id','Store','Box','Stock Date']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined) {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.profile_id,
                  i.email,
                  i.invoice_id,
                  i.item_name,
                  i.stock_code,
                  i.pickup_code,
                  i.bin_id,
                  i.store,
                  i.box,
                  i.stocked_date? this.convertToTimeZone(i && i.stocked_date) : '',
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "AssignedItemsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
        this.setState({ loader: false });
      })
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          this.setState({ boxvalues: boxlist });
          this.setState({ loader: false });
        });
    }

  }

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource(this.state.boxvalues, this.state.accountValues)
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.fromdate = '';
      TransactionFilterObj.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  exportPDF = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'printAssignedItems', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then((response) => {
        try {
          return response.text()
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        let x = window.open('', 'title', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,top=100,left=145');
        x.document.write(res);
        x.document.close();
        setTimeout(() => {
          x.print();
          x.close();
          this.setState({ loader: false });
        }, 1300)
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.error(error)
      })
  }

  getServerSideDatasource = (boxvalues, accountValues) => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set box_ids
        if (filterObject.box) {
          const filterValues = filterObject.box.values;
          if (filterValues.length > 0) {
            TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
              return filterValues.includes(boxes.name)
            }).map(box => box.id)
          }
        } else {
          TransactionFilterObj.box_ids = []
        }

        // to set store_ids
        if (filterObject.store) {
          const filterValues = filterObject.store.values;
          TransactionFilterObj.store_ids = accountValues.filter(accounts => {
            return filterValues.includes(accounts.name)
          }).map(store => store.id)
        } else {
          TransactionFilterObj.store_ids = []
        }

        // to set fromdate and todate
        if (filterObject.stocked_date) {
          const dateValue = filterObject.stocked_date;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.fromdate = date
              TransactionFilterObj.todate = ''
            } else {
              TransactionFilterObj.todate = date
              TransactionFilterObj.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.todate = '';
          TransactionFilterObj.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        // const element = document.activeElement
        const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
        const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)

        if (isStoreNotSelected === true || isBoxNotSelected === true) {
          // store or box is not selected, so empty data
          params.successCallback([], 0)
          self.setState({ data: [], isButtonDisabled: true })
        } else { // store or box is selected
          apiCall()
        }
      

        function apiCall() {
          self.setState({ loader: true })
          fetch(process.env.REACT_APP_BASEURL + 'apis/i-ecom/orders/order/getStockeditems', {
            method: 'post',
            withCredentials: true,
            headers: {
              'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                self.setState({ loader: false })
                return null;
              }
            })
            .then(response => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            })
        }
      }
    };
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  AmountValueRenderer = (params) => {
    return params.value ? '$' + parseFloat(params.value).toFixed(2) : '$0.00'
  }

  render() {
    const { classes, t } = this.props;
    const { data,boxvalues,accountValues } = this.state;

    const columnDefs = [
      { field: "profile_id", headerName: "Profile" },
      { field: "email", headerName: "Email" },
      { field: "invoice_id", headerName: "Invoice" },
      { field: "item_name", headerName: "Items" },
      { field: "stock_code", headerName: t("Report.Assign.StockCode") },
      { field: "pickup_code", headerName: t("Report.Assign.PUCode") },
      { field: "bin_id", headerName: t("Report.Assign.BIN") },
      {
        field: "store", headerName: t("Report.Assign.Store"), filter: true,
        filterParams: {
          values: accountValues.map(account => {
            return account.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "box", headerName: t("Report.Assign.Location"), filter: true,
        filterParams: {
          values: boxvalues.map(box => {
            return box.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "stocked_date", headerName: t("Report.Stocked.StockDate"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Stocked.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Stocked.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      // { field: "username", headerName: t("Report.Assign.User") },
    ];

    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <Box component="div">
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
              <Tooltip key="clear-filters" title={t("Report.Assign.ClearFiltersTooltip")}>
                <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                  <CloseIcon style={{ color: "white" }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="export-csv" title={t("Report.Assign.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="export-pdf" title={t("Report.Assign.ExportPDFTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportPDF"
                  onClick={() => { this.exportPDF() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        {this.state.accountValues.length && this.state.boxvalues.length ?
          <ReportsAGGrid
            columnDefs={columnDefs}
            sideBar={false}
            suppressMenuHide={true}
            rowData={data}
            defaultColDef={{
              flex: 1,
              minWidth: 150,
              floatingFilter: true,
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: [{
                  displayKey: 'searchtext',
                  displayName: 'Search Text',
                  predicate: (cellValue) => cellValue
                }],
                maxNumConditions: 1,
              },
              resizable: true,
              sortable: true,
              menuTabs: ['generalMenuTab', 'columnsMenuTab'],
            }}
            onGridReady={this.onGridReady}
          />
          : null
        }
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));


// WEBPACK FOOTER //
// ./src/components/reports/retail-stocked-items/index.js